import { useTranslation } from "react-i18next";

import { Bold } from "capitalrx-components-2.0/lib/typography";
import { Shelf, Stack } from "capitalrx-components-2.0/lib/layout";
import { formatZip } from "capitalrx-utilities";

import { Body } from "@/basic/components";

import styles from "./styles.module.scss";

interface ListItemProps {
  readonly name: string;
  readonly distance: string;
  readonly tags?: string[];
  readonly address1: string;
  readonly address2?: string;
  readonly city: string;
  readonly state: string;
  readonly zip_code: string;
  readonly providerId: string;
  readonly handleItemClick: (data: string) => void;
}

export const ListItem = (props: ListItemProps) => {
  const { t: translate } = useTranslation();
  const { name, distance, address1, address2, city, state, zip_code, providerId, handleItemClick } = props;

  return (
    <button className={styles["ListItemWrapper"]} onClick={() => handleItemClick(providerId)}>
      <Stack className={styles["ListItemStack"]}>
        <div className={styles["ListItemHeader"]}>
          <Shelf>
            <Body size="medium" className="ListItemName">
              <Bold>{name}</Bold>
            </Body>
            <Shelf.Spacer />
            <Body>{`${parseFloat(distance).toFixed(2)} ${translate("LIST_ITEM.miles")}`}</Body>
          </Shelf>
        </div>

        <div className={styles["ListItemAddress"]}>
          <Body>{address1}</Body>
          {address2 && <Body>{address2}</Body>}
          <Body>{`${city}, ${state} ${formatZip(zip_code)}`}</Body>
        </div>
      </Stack>
    </button>
  );
};
